(() => {
  const parse = value => String(value ?? '').split(',').map(part => part.trim()).filter(Boolean).flatMap(part => {
    const fields = part.split(':').map(field => field.trim());
    if (fields.length !== 2 || fields.some(field => field === '')) return [];
    const [min,percent] = fields.map(Number);
    return Number.isSafeInteger(min) && min >= 1 && Number.isFinite(percent) && percent >= 0 && percent <= 100 ? [{min,percent}] : [];
  });
  const percent = (tiers,quantity) => quantity > 1000 ? 0 : tiers.reduce((rate,tier) => quantity >= tier.min ? tier.percent : rate,0);
  const unit = (cents,tiers,quantity) => Math.ceil(cents * (10000 - Math.round(percent(tiers,quantity) * 100)) / 10000);
  window.StepUpGarmentPricing = {parse,percent,unit};
})();
